import './Editor.css';
import { ContentState, convertToRaw } from 'draft-js';
import { useField } from 'react-final-form';
import Loadable from 'react-loadable';
import React from 'react';
const LoadableEditor = Loadable({
    loader: async () => (await import('react-draft-wysiwyg')).Editor,
    loading: () => React.createElement("div", null, "Loading..."),
});
export const WysiwygEditorField = ({ name, placeholder }) => {
    const { input: { value, onChange }, } = useField(name);
    const editorOptions = {
        options: [
            'inline',
            'blockType',
            'fontSize',
            'fontFamily',
            'textAlign',
            'colorPicker',
            'list',
            'emoji',
            'link',
            'image',
            'remove',
        ],
        blockType: {
            options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote'],
        },
        link: {
            defaultTargetOption: '_blank',
        },
    };
    const editorContentState = value === '' ? convertToRaw(ContentState.createFromText(value)) : JSON.parse(value);
    const handleChange = (contentState) => {
        onChange(JSON.stringify(contentState));
    };
    return (React.createElement(LoadableEditor, { initialContentState: editorContentState, onContentStateChange: handleChange, toolbar: editorOptions, placeholder: placeholder }));
};
//# sourceMappingURL=WysiwygEditorField.js.map